/**
 * ============================================================================
 * [P3-02-E] LineChart - 라인 차트 컴포넌트
 *
 * Chart.js를 사용한 라인 차트
 * - 일별 작성 추이 시각화
 * ============================================================================
 */

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import styles from './Tracking.module.css'

// ============================================================================
// [P3-02-E] Chart.js 등록
// - 필요한 컴포넌트만 등록하여 번들 크기 최적화
// ============================================================================
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

// ============================================================================
// Types
// ============================================================================
interface LineChartProps {
  data: {
    labels: string[]
    values: number[]
  }
  title: string
}

// ============================================================================
// [P3-02-E] LineChart Component
// ============================================================================
export function LineChart({ data, title }: LineChartProps) {
  // ========================================================================
  // 차트 데이터 구성
  // ========================================================================
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: title,
        data: data.values,
        borderColor: '#667eea',
        backgroundColor: 'rgba(102, 126, 234, 0.1)',
        fill: true,
        tension: 0.4,
        pointRadius: 3,
        pointHoverRadius: 5,
      },
    ],
  }

  // ========================================================================
  // 차트 옵션
  // ========================================================================
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: title,
        font: { size: 14, weight: 'bold' as const },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 1 },
      },
    },
  }

  // ========================================================================
  // Render
  // ========================================================================
  return (
    <div className={styles.chartWrapper}>
      <Line data={chartData} options={options} />
    </div>
  )
}

export default LineChart
